import React from 'react';

import Background from '../images/apply-background-1.png';

import '../style/apply1.css';

function Apply1() {
  return (
    <div className="middle-1-apply">
      <div className="container-all">
        <img alt="" style={{ width: '100%', position: 'relative', top: '-2px' }} className="background-1" src={Background} />
        <div className="centered">
          <h2>Aplique-se na Alliance</h2>
        </div>
      </div>
    </div>
  );
}

export default Apply1;
